<div #doughnut class="doughnut-chart h-100" [class.d-none]="doughnutChartLegends && !doughnutChartLegends.length"></div>